export interface SupportLanguage {
	code: string;
	checked: boolean;
}

export class UserLanguage {
	name: string = null;
	code: string = null;
}

export class UserTimeLogOff {
	name: string = null;
	value: number = null;
}
